// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__mVvOv","paginationItemLink":"Pagination_paginationItemLink__3gM-F","paginationItemLinkActive":"Pagination_paginationItemLinkActive__zlPP2"};